<nav class="tabs">
  <ul class="tabs__list">
    <li
      *ngFor="let tab of tabs"
      (click)="emitSelectedTab(tab)"
      class="tabs__list-item"
      [class.tabs__list-item_active]="isTabActive(tab)"
    >
      {{ tab }}
    </li>
  </ul>
</nav>
